const shippingElement = document.querySelector('[data-shipping]');
const shipping = shippingElement ? parseFloat(shippingElement.getAttribute('data-shipping')) : 0;

let hasCrossedThreshold = false;
let idTimer;
let previousTotalPrice;

function checkCartValueAndNotify(threshold) {
  const nutrientTrackerElement = document.querySelector(".nutrient-tracker");
  const notifyElement = document.querySelector('.shipping-notify');

  if (nutrientTrackerElement && nutrientTrackerElement.classList.contains('active')) {
    notifyElement.classList.remove("active");
    return;
  }

  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      let totalPrice = data.total_price;

      if (totalPrice >= threshold && previousTotalPrice < threshold) {
        if (!hasCrossedThreshold) {
          hasCrossedThreshold = true;
          showNotificationWithProgressBar(notifyElement);
        }
      } else {
        hasCrossedThreshold = false;
      }
      previousTotalPrice = totalPrice;
    })
    .catch((error) => {
      console.error('cart error:', error);
    });
}

function showNotificationWithProgressBar(element) {
  element.classList.add('active');

  clearTimeout(idTimer);
  idTimer = setTimeout(() => {
    element.classList.remove("active");
    closeNotification(element);
  }, 3000);
}

function closeNotification(element) {
  element.classList.remove('active');
}

document.querySelector('.shipping-notify__close-button').addEventListener('click', function () {
  let notifyElement = document.querySelector('.shipping-notify');
  closeNotification(notifyElement);
});

document.addEventListener('line-item:change:end', function (evt) {
  checkCartValueAndNotify(shipping);
});

document.addEventListener('cart:item-added', function (evt) {
  checkCartValueAndNotify(shipping);
});
